// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuthForm {
  width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 38px;
}
.AuthForm .wrapperField {
  position: relative;
}
.AuthForm .wrapperField:nth-child(2) {
  padding-bottom: 32px;
}
.AuthForm .wrapperField .errorMessage {
  margin-top: 8px;
  font-size: 14px;
  font-family: "Montserrat Regular";
  color: #eb5757;
}
.AuthForm .wrapperField .titleField {
  font-family: "Montserrat Regular";
  color: white;
}
.AuthForm .wrapperField .passwordEye {
  cursor: pointer;
  position: absolute;
  top: 27px;
  right: 20px;
}
.AuthForm .wrapperField .passwordEye.show path {
  fill: #B910C6;
}
.AuthForm .wrapperField .AuthInput {
  margin-top: 8px;
  padding-left: 16px;
  width: 398px;
  font-size: 20px;
  font-family: "Montserrat Regular";
  border: 1px solid #F1F1F1;
  outline: none;
  border-radius: 100px;
  height: 60px;
  background-color: #F1F1F1;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/AuthPage/AuthForm/AuthForm.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AADF;AAEE;EACE,kBAAA;AAAJ;AACI;EACE,oBAAA;AACN;AAEI;EACE,eAAA;EACA,eAAA;EACA,iCAAA;EACA,cAAA;AAAN;AAEI;EACE,iCAAA;EACA,YAAA;AAAN;AAEI;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAAN;AAGQ;EACE,aAAA;AADV;AAKI;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;EACA,yBAAA;EACA,aAAA;EACA,oBAAA;EACA,YAAA;EAEA,yBAAA;AAJN","sourcesContent":["@import '~@assets/styles/colorsVariables.scss';\r\n\r\n.AuthForm {\r\n  width: 360px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 38px;\r\n  .wrapperField {\r\n    position: relative;\r\n    &:nth-child(2) {\r\n      padding-bottom: 32px;\r\n    }\r\n\r\n    .errorMessage {\r\n      margin-top: 8px;\r\n      font-size: 14px;\r\n      font-family: 'Montserrat Regular';\r\n      color: #eb5757;\r\n    }\r\n    .titleField {\r\n      font-family: 'Montserrat Regular';\r\n      color: white;\r\n    }\r\n    .passwordEye {\r\n      cursor: pointer;\r\n      position: absolute;\r\n      top: 27px;\r\n      right: 20px;\r\n      // margin: 24;\r\n      &.show {\r\n        path {\r\n          fill: #B910C6;\r\n        }\r\n      }\r\n    }\r\n    .AuthInput {\r\n      margin-top: 8px;\r\n      padding-left: 16px;\r\n      width: 398px;\r\n      font-size: 20px;\r\n      font-family: 'Montserrat Regular';\r\n      border: 1px solid #F1F1F1;\r\n      outline: none;\r\n      border-radius: 100px;\r\n      height: 60px;\r\n      // color: white;\r\n      background-color: #F1F1F1;\r\n\r\n      &::placeholder {\r\n        // color: $secondaryText;\r\n      }\r\n      &:focus,\r\n      &.notEmpty {\r\n        // border: 1px solid white;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AuthForm": `AuthForm`,
	"wrapperField": `wrapperField`,
	"errorMessage": `errorMessage`,
	"titleField": `titleField`,
	"passwordEye": `passwordEye`,
	"show": `show`,
	"AuthInput": `AuthInput`
};
export default ___CSS_LOADER_EXPORT___;
